import React from "react";
import { PropTypes } from "prop-types";

import "./../Navigation.scss";

var SideNavBar = function SideNavBar(_ref) {
  var children = _ref.children,
      logo = _ref.logo;

  return React.createElement(
    "div",
    { className: "side-navigation" },
    React.createElement(
      "div",
      { className: "logo-container" },
      logo && React.createElement("img", { src: logo })
    ),
    children
  );
};

SideNavBar.defaultProps = {};
SideNavBar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**Company logo url */
  logo: PropTypes.string
} : {};
export default SideNavBar;